module.exports = __webpack_public_path__ + "img/service-kandash.96becc2.webp";